const KEY = "perfero_text_scale";

export const SCALES = [
  { id: "base", value: "100%", label: "Testo normale" },
  { id: "lg", value: "112.5%", label: "Testo grande" },
  { id: "xl", value: "125%", label: "Testo molto grande" },
];

export const getStoredScale = () => {
  try {
    return localStorage.getItem(KEY) || "base";
  } catch {
    return "base";
  }
};

export const applyScale = (id) => {
  const scale = SCALES.find((s) => s.id === id) ?? SCALES[0];
  document.documentElement.style.fontSize = scale.value;
  try {
    localStorage.setItem(KEY, scale.id);
  } catch {
    /* storage unavailable */
  }
};
